import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardWidgets, ReportsContainer } from '../modules/reports';
import { useSession } from '../auth/SessionContext';

export default function DashboardsPage() {
  const navigate = useNavigate();
  const { user, loading } = useSession();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/login', { replace: true });
    }
  }, [loading, user, navigate]);

  if (loading || !user) {
    return null;
  }

  return (
    <>
      <DashboardWidgets />
      <ReportsContainer />
    </>
  );
}
